import { round } from '../../number/round';
import fileSizes from '../fileSizes';
/**
 * Formats a file size in bytes to a string with a maximum specified number of significant digits
 *
 * @category File
 * @since v1.0.0
 * @param  {number} sizeInBytes - The size of the file in bytes
 * @param  {number} maxSignificantDigits - The maximum number of significant digits to display. (e.g. '0' would round to a whole number, '2' would round to at most two decimal places)
 * @returns {string} - The formatted file size.
 * @example
 * formatFileSizeString(74142, 2) //=> '72.4 KB'
 * formatFileSizeString(70189, 2) //=> '68.54 KB'
 * @docgen_example
 * formatFileSizeString(74142, 2);
 */
export var formatFileSizeString = function (sizeInBytes, maxSignificantDigits) {
    if (maxSignificantDigits === void 0) { maxSignificantDigits = 2; }
    if (sizeInBytes >= fileSizes.tb) {
        return round((sizeInBytes / fileSizes.tb), maxSignificantDigits) + ' TB';
    }
    else if (sizeInBytes >= fileSizes.gb) {
        return round((sizeInBytes / fileSizes.gb), maxSignificantDigits) + ' GB';
    }
    else if (sizeInBytes >= fileSizes.mb) {
        return round((sizeInBytes / fileSizes.mb), maxSignificantDigits) + ' MB';
    }
    else if (sizeInBytes >= fileSizes.kb) {
        return round((sizeInBytes / fileSizes.kb), maxSignificantDigits) + ' KB';
    }
    return sizeInBytes + ' B';
};
